import { Component, OnInit } from '@angular/core';
import {TranslationsService} from '../services/translations.service';
import {AboutService} from '../services/about.service';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {BuildingService} from '../services/building.service';
import {RoomsService} from '../services/rooms.service';
import {SEOService} from '../services/seoservice.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  active: any = [true, false, false, false, false, false, false];
  defaultLanguage: string;
  words: any;
  languages: any;
  activeLang: any = [];
  lang: any;
  rates: any = [
    {
      name: 'USD',
      value: ''
    }, {
      name: 'EUR',
      value: ''
    }, {
      name: 'RUB',
      value: ''
    }
  ];
  logo: string;
  url: any;
  buildings: any;
  roomCats: any;
  info: any;
  buildingId: string;
  constructor(private translationsService: TranslationsService,
              private router: Router,
              private roomsService: RoomsService,
              private buildingService: BuildingService,
              private seoservice: SEOService,
              private abouteService: AboutService) {
    this.translationsService.langName$.subscribe((res) => {
      this.lang = res;
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.url = event.url;
        if (this.url === '/home') {
          this.active = [true, false, false, false, false, false, false];
        }
      }
    });
  }

  ngOnInit() {
    // this.seoservice.getMetaTags();
    this.abouteService.getLogo().subscribe( res => {
      if (!res.error) {
        this.logo = res.logo;
      }
    });
    this.abouteService.getInfo().subscribe( res => {
      if (!res.error) {
        this.info = res.data[0];
      }
    });
    this.lang = localStorage.getItem('lang');
    if (window.location.pathname.indexOf('home') >= 0) {
      this.active = [true, false, false, false, false, false, false];
    }else if (window.location.pathname.indexOf('about') >= 0) {
      this.active = [false, true, false, false, false, false, false];
    }else if (window.location.pathname.indexOf('room') >= 0) {
      this.active = [false, false, true, false, false, false, false];
    }else if (window.location.pathname.indexOf('swiming-pool') >= 0) {
      this.active = [false, false, false, true, false, false, false];
    }else if (window.location.pathname.indexOf('bar') >= 0 || window.location.pathname.indexOf('restaurant') >= 0) {
      this.active = [false, false, false, false, true, false, false];
    }else if (window.location.pathname.indexOf('special-offers') >= 0) {
      this.active = [false, false, false, false, false, true, false];
    }else if (window.location.pathname.indexOf('contact-us') >= 0) {
      this.active = [false, false, false, false, false, false, true];
    }
    this.translationsService.getRate().subscribe( res => {
      if ( !res.error) {
        const parser = new DOMParser();
        const Rates = parser.parseFromString(res.data, 'text/xml').getElementsByTagName('Rates')[0].childNodes;
        for (let i = 0; i < Rates.length; i++) {
          for (let j = 0; j < this.rates.length; j++) {
            if (Rates[i].childNodes[0].textContent === this.rates[j].name) {
              this.rates[j].value = +Rates[i].childNodes[2].textContent;
            }
          }
        }
      }else {
        this.rates = [];
      }
    });
    this.translationsService.getTranslations().subscribe(res => {
      if (!res.error) {
        this.words = res.data[0];
        this.translationsService.getLanguages().subscribe(resp => {
          if (!resp.error) {
            this.languages = resp.data;
            this.buildingService.getBuildings().subscribe(response => {
              if (!response.error) {
                this.buildings = response.data;
                this.roomsService.getRoomsCats().subscribe( respo => {
                  if (!respo.error) {
                    this.roomCats = respo.data;
                  }
                });
              }
            });
            if (!localStorage.getItem('lang')) {
              for (let i = 0; i < this.languages.length; i++) {
                if (this.languages[i].symbol === 'arm') {
                  this.checkLanguage(this.languages[i].symbol);
                }
              }
            }else {
              this.checkLanguage(localStorage.getItem('lang'));
            }
          }
        });
      }
    });
  }

  checkLanguage(symbol) {
    for (let i = 0; i < this.languages.length; i++) {
      this.activeLang.push({ type: false});
      if ( !localStorage.getItem('lang')) {
        if ( this.languages[i].symbol === symbol) {
          this.defaultLanguage = this.languages[i].image;
          this.translationsService.setLang(symbol);
          localStorage.setItem('lang', this.languages[i].symbol);
          this.lang = localStorage.getItem('lang');
          this.activeLang[i] = { type: true};
        }else {
          this.activeLang[i] = { type: false};
        }
      }else {
        if (localStorage.getItem('lang') === this.languages[i].symbol) {
          this.activeLang[i] = { type: true};
          this.defaultLanguage = this.languages[i].image;
          this.translationsService.setLang(symbol);
          this.lang = localStorage.getItem('lang');
        }else {
          this.activeLang[i] = { type: false};
        }
      }
    }
  }

  urlChange(ind) {
    for (let i = 0; i < 7; i++) {
      if (i === ind) {
        this.active[i] = true;
      }else {
        this.active[i] = false;
      }
    }
  }

  changeLanguage(symbol, index) {
    localStorage.setItem('lang', symbol);
    this.translationsService.setLang(symbol);
    for (let i = 0; i < this.languages.length; i++) {
      if (i === index) {
        this.defaultLanguage = this.languages[i].image;
        this.activeLang[i] = { type: true};
      }else {
        this.activeLang[i] = { type: false};
      }
    }
    this.checkLanguage(symbol);
  }

}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/header/header.component.ts